module.exports = __webpack_public_path__ + "media/app/assets/covenants/necrolord-154773a5ab489849d95354d4da37f47e.png";